import { HeaderSize, HeaderText } from '@/components/ui/HeaderText';
import { TypePlayKitPageTranslations } from '@/utils/translations/types/TypePlayKitPageTranslations';
import React from 'react';
import { UpsellCard } from '../../../_components/UpsellCard';
import { constructLegacyCustomerPortalLink } from '@/utils/shopSubdomain';
import useLocale from '@/hooks/useLocale';
import { trackClickEvent } from '../../utils';
import { CTA_NAMES } from '@/utils/rudderstack';

export type LayoutCancelledProps = {
  t: TypePlayKitPageTranslations;
  userUuid: string;
  subscriptionUuid: string;
};

function LayoutCancelledSubscription({
  t,
  userUuid,
  subscriptionUuid,
}: LayoutCancelledProps) {
  const locale = useLocale();
  const reactivateSubscriptionLink = constructLegacyCustomerPortalLink(locale, [
    userUuid,
    'account-settings',
    'reactivate',
    subscriptionUuid,
  ]);
  return (
    <div data-testid="layout-cancelled-subscription" className="text-center">
      <HeaderText
        classes="pb-2"
        size={HeaderSize.H1}
        align="left"
        text={t.subscriptionCancelled}
      />
      <UpsellCard
        headerText={t.reactivateAndSave}
        subText={t.reactivateSubtext}
        ctaText={t.reactivateToday}
        ctaLink={reactivateSubscriptionLink}
        onClick={() => {
          trackClickEvent(CTA_NAMES.REACTIVATE_SUBSCRIPTION);
        }}
      />
    </div>
  );
}

export default LayoutCancelledSubscription;
